import { VOLUME_BUZZER, VOLUME_BUZZER_STREAM, } from "../../../interface/iVolumeBuzzer";
import { drivingMarketStreamingUpdate, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
let initState = {
    data: [],
};
const volumeBuzzer = (state = initState, action) => {
    switch (action.type) {
        case VOLUME_BUZZER:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case VOLUME_BUZZER_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketStreamingUpdate(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default volumeBuzzer;
